import __ from '../util/localization'

export default {
  methods: {
    /**
     * Translate the given key.
     */
    __(key, replace) {
      return __(key, replace)
    },
  },
}
